import { Image } from '@cian/ui-kit';

import { type FC } from 'react';

import styles from './styles.css';

interface IBannerProps {
  image: string;
  hitUrl: string;
  disclaimer?: string;
}

export const Banner: FC<IBannerProps> = ({ disclaimer, image, hitUrl }) => {
  return (
    <a className={styles['container']} data-testid="banner" href={hitUrl} rel="noopener noreferrer" target="_blank">
      <div className={styles['content']}>
        <Image borderRadius={0} height={220} src={image} width={1100} />
      </div>
      {disclaimer && (
        <div className={styles['disclaimer']} data-testid="banner-disclaimer">
          {disclaimer}
        </div>
      )}
    </a>
  );
};
